import { render, staticRenderFns } from "./event_order_attendance.vue?vue&type=template&id=4a2dedbd&"
import script from "./event_order_attendance.vue?vue&type=script&lang=js&"
export * from "./event_order_attendance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports